"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Navigation = void 0;
var _react = _interopRequireDefault(require("react"));
var _CardBox = require("b2b-components/theme/components/CardBox");
var _key = require("b2b-components/utils/key");
var _classnames = _interopRequireDefault(require("classnames"));
var _Group = require("./Group");
var _ = require("./");
require("./Navigation.scss");
const Navigation = _ref => {
  let {
    className,
    groups,
    onLinkClick,
    styleType = _.NAVIGATION_STYLE_TYPE.vertical
  } = _ref;
  const rootClassName = (0, _classnames.default)('cds-Navigation', {
    'cds-Navigation--Horizontal': styleType === _.NAVIGATION_STYLE_TYPE.horizontal
  }, className);
  return /*#__PURE__*/_react.default.createElement(_CardBox.CardBox, {
    className: rootClassName,
    titleSize: _CardBox.CARD_BOX_TITLE_SIZE.default
  }, Array.isArray(groups) && groups.map((group, index) => /*#__PURE__*/_react.default.createElement(_Group.Group, {
    key: (0, _key.createKey)(index, 'group'),
    group: group,
    onLinkClick: onLinkClick
  })));
};
exports.Navigation = Navigation;
//# sourceMappingURL=Navigation.js.map